export const reportObjectTypeList = [
  { label: "CASE_DOC_SIGN", value: "CaseDocsign" },
  { label: "JOB_TITLE", value: "JobTitle" },
  { label: "USER_PROFILE", value: "UserProfile" },
  { label: "BUSINESS_UNIT", value: "BusinessUnit" },
  { label: "USER", value: "UserForm" },
  { label: "UPLOAD_DOCUMENT_INVALID", value: "InvalidProcessDetail" },
  { label: "DOCUMENT_STATISTIC_NEARLY_EXPIRED", value: "DocsignNearlyExpired" },
  { label: "DOCUMENT_STATISTIC_BY_CASE", value: "DocsignByCaseManagement" },
];

export const reportAuthStatus = [
  { key: "P", badgeColor: "warning" },
  { key: "A", badgeColor: "success" },
  { key: "R", badgeColor: "danger" },
];

export const reportAuthStatusMode = {
  PROCESSING: "P",
  COMPLETED: "A",
};

export const reportModeList = {
  VIEW_REPORT_DETAIL: "VIEW_REPORT_DETAIL",
  EDIT_REPORT_DETAIL: "EDIT_REPORT_DETAIL",
};

export const initOptionDateLocale = {
  altInput: true,
  altFormat: "d/m/Y",
  dateFormat: "d/m/Y",
  // shorthandCurrentMonth:true,
  locale: {
    firstDayOfWeek: 1,
  },
};

export const getInitReportParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
  };
};

export const REPORT_TYPE_KPI_PERFORMANCE = "REPORT_TYPE_KPI_PERFORMANCE";

export const KPI_STATUS_OPTIONS = [
  { value: "success", label: "Đạt" },
  { value: "fail", label: "Không đạt" },
  { value: "in_progress", label: "Đang xử lý" },
];

export function buildReportYearOptions() {
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let year = 2022; year <= currentYear + 1; year += 1) {
    years.push({
      value: year,
      label: String(year),
    });
  }

  return years.reverse();
}

export function getDefaultReportYearOption() {
  const currentYear = new Date().getFullYear();

  return {
    value: currentYear,
    label: String(currentYear),
  };
}

export function buildReportYearDateRange(year) {
  const normalizedYear = Number(year) || new Date().getFullYear();

  return {
    from_date: `${normalizedYear}-01-01`,
    to_date: `${normalizedYear}-12-31`,
  };
}
